import { ComponentType, lazy, LazyExoticComponent } from 'react';

// ==============================|| LAZY IMPORT CU RECUPERARE CONTROLATĂ ||============================== //
// După un deploy, shell-ul vechi din browser referă hash-uri de chunk care nu mai există pe
// server → `import()` unei rute lazy încă neîncărcate dă „Failed to fetch dynamically imported
// module" și crapă ruta (Suspense NU prinde erori de încărcare). În loc de crash, facem UN
// SINGUR reload — aduce `index.html` + harta de chunk-uri noi, deci ruta se încarcă din a doua.
//
// Guard pe timp (fereastră scurtă): dacă tocmai am reîncărcat și tot eșuează (chunk chiar
// lipsă / bug real, nu doar stale-after-deploy), NU mai buclăm — propagăm eroarea către
// ErrorBoundary. Flag-ul stă în sessionStorage (per tab), nu se șterge la succes, ca să nu
// intrăm în buclă „succes-parțial → eșec → reload".
//
// NOTĂ infra: reload-ul recuperează doar dacă `index.html` e servit `no-cache` (altfel
// reload-ul aduce tot harta veche). Shell-ul SPA trebuie să fie no-cache la deploy.

const RELOAD_FLAG = 'app:chunk-reload-at';
const RELOAD_WINDOW_MS = 10_000;

// Semnătura oglindește React.lazy (constrângere pe `ComponentType<any>`), ca să accepte
// orice componentă de rută, indiferent de props.
export function lazyRetry<T extends ComponentType<any>>(
	factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
	return lazy(() =>
		factory().catch((error: unknown) => {
			const last = Number(window.sessionStorage.getItem(RELOAD_FLAG) || 0);
			const now = Date.now();
			// Am reîncărcat deja recent și tot eșuează → nu buclăm, lăsăm eroarea să iasă.
			if (now - last < RELOAD_WINDOW_MS) {
				throw error;
			}
			window.sessionStorage.setItem(RELOAD_FLAG, String(now));
			window.location.reload();
			// Reload-ul e imediat; întoarcem o promisiune care nu se rezolvă niciodată, ca
			// nimic (nici eroarea) să nu se randeze până se schimbă pagina.
			return new Promise<{ default: T }>(() => {});
		})
	);
}
